module.exports = __webpack_public_path__ + "media/images/c-adminSidebarLink/distribution_reservations-9ed299984cf7a4663508f67592846d18.svg";